import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 2rem;
  color: #3a3a3a;
`;

export const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const CardHeader = styled.div`
  background-color: #fff;
  text-align: right;
  border-bottom-width: 0;

  p {
    color: #6c757d;
    margin-bottom: 0.25rem;
  }
`;

export const CardIconContainer = styled.div`
  padding: 1.5rem 2rem;
  margin-top: -25px;
  margin-right: 0;
  float: left;
  color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
`;
